export default __webpack_public_path__ + "static/media/HUMID.7b52bc19.webp";